import { createApi } from '@reduxjs/toolkit/query/react'
import queryString from 'query-string';
import { ICars } from '../../types'
import axiosBaseQuery from './API'

// Define a service using a base URL and expected endpoints
interface ICarData {
  delete: any,
  results:ICars[]
}
interface IFilter {
  markId?:number,
  model?:number, 
  startYear?:number, 
  endYear?:number,
  priceFrom?:number,
  priceTo?:number,
  limit?:number,
  offset?:number,
  location?:string
}

export const carsApi = createApi({
  reducerPath: 'carsApi',
  tagTypes:['Cars'],
  baseQuery: axiosBaseQuery({ baseUrl: process.env.REACT_APP_API_KEY }),
  endpoints: (builder) => ({
    getCarsByMark: builder.query<any, IFilter>({
      query: (data) => {
        const stringified = queryString.stringify(data);
       return {url:`cars/all/?${stringified}`, method:'GET'}
      },
      providesTags: [{ type: 'Cars' }],
    }),
    getCarsById: builder.query<any, {id?:string}>({
      query: ({id}) => {
       return {url:`cars/${id}`, method:'GET'}
      },
      providesTags: [{ type: 'Cars' }],
    }),
    addCars: builder.mutation<any, Partial<any>>({
      query(body) {
        return {
          url: `cars`,
          method: 'POST',
          data:body,
        }
      },
      invalidatesTags: [{ type: 'Cars' }],
    }),
    editCar: builder.mutation<any, Partial<any>>({
      query(body) {
        const {id, ...rest}=body;
        return {
          url: `cars/${id}`,
          method: 'PUT',
          data:rest,
        }
      },
      invalidatesTags: [{ type: 'Cars' }],
    }),
    deleteCar: builder.mutation<ICars, {id:number | null}>({
      query({id}) {
        return {
          url: `cars/${id}`,
          method: 'DELETE',
        }
      },
      invalidatesTags: [{ type: 'Cars'}],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { 
  useGetCarsByMarkQuery, 
  useGetCarsByIdQuery,
  useAddCarsMutation, 
  useDeleteCarMutation, 
  useEditCarMutation
 } = carsApi